// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"d71539bf","769":"29a6d7ac"}[chunkId] + ".chunk.js";
};